import * as React from 'react';
import { Box, Grid, ListItem, Text, UnorderedList } from "@chakra-ui/layout";
import { StorageTipsPropTypes } from "./StorageTipsPropTypes";
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from "@chakra-ui/accordion";

export const StorageTips = ({ generalTipsList = [], specificTipsList = [] }: StorageTipsPropTypes.IStorageTipsProps) => {
    return (
        <Grid
            templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)' }}
            gap='32px'
            padding={{ base: '16px', sm: '64px' }}
            color='text.silver'
            bg='background.main'
            maxW={{ base: '100%', sm: '720px', md: '1092px' }}
            h={'auto'}
            justifyContent={'center'}
            maxWidth="1000px"
        >
            {
                !!generalTipsList.length &&
                <UnorderedList w='100%'>
                    {
                        generalTipsList.map(({ tip }, index) => <ListItem key={index}><Text p='5px 0' textStyle='subtitle'>{tip}</Text></ListItem>)
                    }
                </UnorderedList>
            }

            <Box w='100%'>
                <Accordion w='100%' allowToggle defaultIndex={[0]}>
                    {
                        specificTipsList.map(({ tipTitle, storageTipsList }, index) => {
                            return <AccordionItem border='none' key={index}>
                                <AccordionButton
                                    h='56px'
                                    bg='brand.primary'
                                    color='brand.secondary'
                                    borderLeftRadius='2px'
                                    border='0.4px solid'
                                    borderColor='brand.primary'
                                    _hover={{
                                        bg: 'brand.primary',
                                        color: 'background.main'
                                    }}
                                >
                                    <Box as='span' flex='1' textAlign='left' noOfLines={2} overflow='hidden'><Text textStyle='body1'>{tipTitle}</Text></Box>
                                    <AccordionIcon boxSize='12' />
                                </AccordionButton>
                                <AccordionPanel padding='20px 20px 20px 16px' backgroundColor={'background.modal'}>
                                    <UnorderedList>
                                        {storageTipsList.map(({ tip }, index) => {
                                            return <ListItem key={index} padding='4px 16px'>
                                                <Text textStyle='body2' fontWeight='600'>{tip}</Text>
                                            </ListItem>
                                        })}
                                    </UnorderedList>
                                </AccordionPanel>
                            </AccordionItem>
                        })
                    }
                </Accordion>
            </Box>
        </Grid>
    )
};
